module.exports = __webpack_public_path__ + "img/plat-title33.f78012aa.png";